import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { FilterPanel } from '@gsa/afp-component-library';
import { useFvsRequirements } from '../../requirements-provider';
import { useFederalStandards } from '../../../fvs-provider';

const { FilterPanelField, FilterPanelFilterShape } = FilterPanel;

const StandardItemFilterItem = ({ filter }) => {
  useFvsRequirements();
  const { standardItemsAsOptions } = useFederalStandards();

  const options = useMemo(() => {
    const baseOptions = standardItemsAsOptions || [];
    return [{ label: 'Select standard item', value: '' }, ...baseOptions];
  }, [standardItemsAsOptions]);

  return (
    <>
      <label htmlFor={filter.key} className="usa-label">
        {filter.title}
      </label>
      <FilterPanelField
        key={[filter.key]}
        filter={{
          ...filter,
          type: 'select',
          options,
        }}
      />
    </>
  );
};

StandardItemFilterItem.propTypes = {
  filter: PropTypes.shape(FilterPanelFilterShape).isRequired,
};

export default StandardItemFilterItem;
